<div class="bg-black w-full max-auto">
    <div class="py-20 mx-auto text-center">
        <p class="text-lg md:text-2xl uppercase">{{texts.footer.newsletter.title}}</p>
        <div class="flex justify-center mt-5">
            <input type="email" [placeholder]="texts.footer.newsletter.placeholder" [(ngModel)]="email" class="rounded-2xl input input-bordered w-1/2 max-w-xs bg-white text-black" />
            <button class="btn bg-green-500 ml-2 rounded-2xl text-black" (click)="submiteNewsletter()">{{texts.footer.newsletter.suscribe_btn}}</button>

        </div>
    </div>
    <footer class="footer lg:footer-horizontal bg-black text-neutral-content p-10 w-3/4 mx-auto">
    
        <nav>
            <h6 class="footer-title">{{texts.footer.titles.tire_product}}</h6>
            <a class="link link-hover" href="tires/product/xnex-sport-ev" routerLink="tires/product/xnex-sport-ev">XNEX Sport EV </a>
            <a class="link link-hover" href="tires/product/xlab-comfort-ev" routerLink="tires/product/xlab-comfort-ev">XLAB Confort EV</a>

        </nav>
        <nav>
            <h6 class="footer-title">{{texts.footer.titles.tire_vehicule}}</h6>
            <a class="link link-hover" href="/tires/vehicle-type/electric-vehicle" routerLink="/tires/vehicle-type/electric-vehicle">{{texts.navbar.llantas.subtitle}}</a>
            
        </nav>
        <nav>
            <h6 class="footer-title" >{{texts.navbar.information.title}}</h6>
            <a class="link link-hover" href="/excellence/technology/" routerLink="/excellence/technology/">{{texts.navbar.information.tecnologia}}</a>
            <a class="link link-hover" href="/excellence/awards/" routerLink="/excellence/awards/">{{texts.navbar.information.premios}}</a>
            <a class="link link-hover" href="/excellence/tire-knowledge/" routerLink="/excellence/tire-knowledge/">{{texts.navbar.information.informacion}}</a>
            <a class="link link-hover" href="/excellence/tuv-sud/" routerLink="/excellence/tuv-sud/">{{texts.navbar.information.tuv_sud}}</a>
        </nav>
        <nav>
            <h6 class="footer-title">{{texts.footer.titles.who_we_are}}</h6>
            <a class="link link-hover" href="/about-us" routerLink="/about-us">{{texts.footer.titles.about}}</a>
            <!--<a class="link link-hover">Medios de comunicación</a>-->
            <a href="/cookies" routerLink="/cookies"  class="link link-hover">{{texts.footer.titles.policy_cookies}}</a>
            <a href="/terms-and-conds" routerLink="/terms-and-conds"  class="link link-hover">{{texts.footer.titles.policy_privacy}}</a>
            <a href="/terms-and-conds-online-sale" routerLink="/terms-and-conds-online-sale"  class="link link-hover">{{texts.footer.titles.terms_conditions}}</a>
        </nav>
        <nav>
            <h6 class="footer-title">{{texts.footer.titles.distributor_title}}</h6>
            <a class="link link-hover" href="/partners" routerLink="/partners">{{texts.footer.titles.distributor_text}}</a>
            
        </nav>
        <nav class="items-center">
            <img src="/assets/logo.webp" class="w-60" alt="Logo" />
            <div class="flex justify-center items-center mx-auto mt-2">
                <a href="https://www.facebook.com/profile.php?id=61577968478344" target="_blank" class="mx-2 inline-flex items-center justify-center gap-2 text-sm 
                                font-medium tracking-wide transition duration-300 rounded-full focus-visible:outline-none 
                                justify-self-center whitespace-nowrap bg-black/60 text-green-500 hover:bg-green-100 
                                hover:text-green-600 focus:bg-green-200 focus:text-green-700 disabled:cursor-not-allowed 
                                disabled:border-green-300 disabled:bg-green-100 disabled:text-green-400 disabled:shadow-none">
                                    <span>
                                        <img src="/assets/img/landing/672a22eeb26999ac92d064e6_icon_fb.svg" class="w-10" alt="" srcset="">
                                    </span>
                                </a>
                                <a href="https://www.instagram.com/mundoev_cr?igsh=MThrd2V0ODByZzhuMQ==" target="_blank" class="mx-2 inline-flex items-center justify-center gap-2 text-sm 
                                font-medium tracking-wide transition duration-300 rounded-full focus-visible:outline-none 
                                justify-self-center whitespace-nowrap bg-black/60 text-green-500 hover:bg-green-100 
                                hover:text-green-600 focus:bg-green-200 focus:text-green-700 disabled:cursor-not-allowed 
                                disabled:border-green-300 disabled:bg-green-100 disabled:text-green-400 disabled:shadow-none">
                                    <span><img src="/assets/img/landing/672a22e440553a7859cb75da_icon_ig.svg" class="w-10" alt="" srcset=""></span>
                                </a>
                                <!-- <button class="mx-2 inline-flex items-center justify-center gap-2 text-sm 
                                font-medium tracking-wide transition duration-300 rounded-full focus-visible:outline-none 
                                justify-self-center whitespace-nowrap bg-black/60 text-green-500 hover:bg-green-100 
                                hover:text-green-600 focus:bg-green-200 focus:text-green-700 disabled:cursor-not-allowed 
                                disabled:border-green-300 disabled:bg-green-100 disabled:text-green-400 disabled:shadow-none">
                                    <span><img src="/assets/img/landing/672a22f839bee918ee0a0731_icon_in.svg" class="w-10" alt="" srcset=""></span>
                                </button>
                                <button class="w-10 h-10 mx-2 inline-flex items-center justify-center gap-2 text-sm 
                                font-medium tracking-wide transition duration-300 rounded-full focus-visible:outline-none 
                                justify-self-center whitespace-nowrap bg-green-500 hover:bg-green-500 
                                hover:text-green-600 focus:bg-green-500 focus:text-green-700 disabled:cursor-not-allowed 
                                disabled:border-green-500 disabled:bg-green-500 disabled:text-green-400 disabled:shadow-none">
                                    <span class="w-7 h-7">
                                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M6.014 8.00613C6.12827 7.1024 7.30277 5.87414 8.23488 6.01043L8.23339 6.00894C9.14051 6.18132 9.85859 7.74261 10.2635 8.44465C10.5504 8.95402 10.3641 9.4701 10.0965 9.68787C9.7355 9.97883 9.17099 10.3803 9.28943 10.7834C9.5 11.5 12 14 13.2296 14.7107C13.695 14.9797 14.0325 14.2702 14.3207 13.9067C14.5301 13.6271 15.0466 13.46 15.5548 13.736C16.3138 14.178 17.0288 14.6917 17.69 15.27C18.0202 15.546 18.0977 15.9539 17.8689 16.385C17.4659 17.1443 16.3003 18.1456 15.4542 17.9421C13.9764 17.5868 8 15.27 6.08033 8.55801C5.97237 8.24048 5.99955 8.12044 6.014 8.00613Z" fill="#000"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M12 23C10.7764 23 10.0994 22.8687 9 22.5L6.89443 23.5528C5.56462 24.2177 4 23.2507 4 21.7639V19.5C1.84655 17.492 1 15.1767 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM6 18.6303L5.36395 18.0372C3.69087 16.4772 3 14.7331 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C11.0143 21 10.552 20.911 9.63595 20.6038L8.84847 20.3397L6 21.7639V18.6303Z" fill="#000"></path> </g></svg>
                                    </span>
                                </button> -->
            </div>
            
            <p class="font-bold text-lg text-center w-full">SAN JOSÉ, COSTA RICA</p>
            <p class="text-center w-full"><a href="mailto:info@prinxcr.com">info&#64;prinxcr.com</a></p>
            <p class="text-center w-full"><a href="tel:+50688979888">+506 88979888</a></p>
            <p class="text-center font-semibold w-full">{{texts.footer.titles.distribuidores_autorizados}}</p>
        </nav>
    </footer>
    <div class="text-center text-base p-4">
        <p class="text-white">
            &copy; <span class="text-green-500">{{getCurrentYear()}}</span> - {{texts.footer.copyright}} 
        </p>
        <p class="text-white">
            {{texts.footer.developer}} 
            <a href="http://rogitsolutions.com" target="_blank" rel="noopener noreferrer" class="text-green-500 hover:text-green-400">
                ROG IT Solutions.
            </a>
        </p>
    </div>
</div>

<div>
    <div
        *ngIf="activeModal"
        class="modal modal-open"
        #modal
        >
        <div class="modal-box">
            <p class="text-xl py-4">{{modalMessage}}</p>
            <div class="modal-action">
            <button class="btn" (click)="closeModal()">Ok</button>
            </div>
        </div>
        </div>
</div>

<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
>
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>